<template>
  <section v-if="popular.length">
    <h1 class="fz-24">
      {{ $t('home.topCoursesTitle') }}
    </h1>
    <swiper v-if="isDesktopScreen" :slides-per-view="'auto'" :key="sliderKey">
      <swiper-slide v-for="data in popular" :key="data.id">
        <RegularCourseCard
          :course-data="data"
          :key="`${data.id}-popular`"
          @click="$router.push(`/course/${data.id}`)"
        />
      </swiper-slide>
    </swiper>
    <div v-else class="mobile-wrap">
      <SinglePodcastMinimized
        v-for="data in popular"
        :key="data.id"
        :course-data="data"
        is-course
        @click="$router.push(`/course/${data.id}`)"
      />
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Grid } from 'swiper/modules';
import RegularCourseCard from '@/components/common/RegularCourseCard';
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import useDeviceScreen from '@/composables/useDeviceScreen';
import SinglePodcastMinimized from '@/components/common/SinglePodcastMinimized.vue';

import 'swiper/css';
import 'swiper/css/grid';

export default {
  name: 'PopularCoursesCarousel',
  components: {
    Swiper,
    SwiperSlide,
    RegularCourseCard,
    SinglePodcastMinimized,
  },
  props: {
    selectedCategory: {
      type: [String, Number],
      default: 'all',
    },
  },

  setup(props) {
    const { isDesktopScreen } = useDeviceScreen();
    const sliderKey = ref(Math.random());
    const store = useStore();
    const modules = [Grid];

    const popular = computed(() => {
      const popular = store.getters['library/getPopularCourses'].slice(0, 10);
      if (props.selectedCategory !== 'all') {
        return popular.filter(
          (course) => course.category_id === props.selectedCategory,
        );
      } else return popular;
    });

    watch(
      () => {
        const watchValue = Array.isArray(popular.value) ? popular.value : [];
        return [...watchValue];
      },
      () => {
        sliderKey.value = Math.random();
      },
    );

    return { sliderKey, popular, isDesktopScreen, modules };
  },
};
</script>

<style scoped lang="scss">
.swiper-slide {
  width: auto;
  text-align: left;
}
.mobile-wrap {
  margin: 10px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
</style>
